<div class="flex w-full flex-col bg-white py-2 rounded-xl">
  <form [formGroup]="customerNotificationForm">
    <div
      class="flex w-full justify-between bg-white py-4 pr-4 border-transparent border border-b-gray-300"
    >
      <div class="flex gap-4 items-center">
        <div class="h-10 w-1 bg-primary rounded-xl"></div>
        <span>Notification Settings</span>
      </div>
      <div
        (click)="notificationMenu = !notificationMenu"
        class="p-1 rounded-full h-6 w-6 bg-gray-300"
      >
        <img src="../../../assets/image/Arrows.svg" />
      </div>
    </div>
    <div *ngIf="notificationMenu" class="flex items-center">
      <div class="gap-2 flex p-4">
        <input [readonly]="(roles == 'merchant' || roles == 'reseller' ) && userRole=='admin'"
          class="bg-transparent border-none"
          type="checkbox"
          class="w-[24px] h-[24px]"
          formControlName="smsNotify"
          ngDefaultControl
        />
        <span>Active SMS Service</span>
      </div>
      <div class="gap-2 flex p-4">
        <input [readonly]="(roles == 'merchant' || roles == 'reseller' ) && userRole=='admin'"
          class="bg-transparent border-none"
          type="checkbox"
          class="w-[24px] h-[24px]"
          formControlName="emailNotify"
          ngDefaultControl
        />
        <span>Active Email Service</span>
      </div>
    </div>

    <!-- <div
      *ngIf="notificationMenu"
      class="flex w-full flex-col bg-white py-2 pt-10 rounded-xl"
    >
      <div
        class="flex w-full justify-between bg-[#F1F1F1] rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4 items-center">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Notification Engine</span>
        </div>
      </div>
      <div class="p-5 grid md:grid-cols-2 grid-col-1 gap-4 w-full">
        <div *ngFor="let item of notification">
          <div class="w-full gap-2 flex">
            <input
              class="bg-transparent border-none"
              type="checkbox"
              class="w-[24px] h-[24px]"
              [formControlName]="item.formControlName"
              ngDefaultControl
            />
            <span>{{ item.heading }}</span>
          </div>
        </div>
      </div>
      <div class="w-full gap-2 flex px-5">
        <input
          class="bg-transparent border-none"
          type="checkbox"
          class="w-[24px] h-[24px]"
          formControlName="TransactionFailedAlert"
          ngDefaultControl
        />
        <span>Transaction Failed Alert</span>
      </div>
      <div class="p-5 gap-4 flex flex-col md:flex-row">
        <div class="w-full gap-2 flex flex-col">
          <span>Merchant Transaction Email</span>

          <input
            formControlName="MerchantTransactionEmailID"
            name="MerchantTransactionEmailID"
            placeholder="Merchant Transaction Email"
            class="w-full border p-2 rounded-md outline-none"
          />
          <div
            *ngIf="customerNotificationForm.controls['MerchantTransactionEmailID'].errors?.['email']"
            class="text-red-500"
          >
            Invalid Email
          </div>
        </div>
        <div class="w-full gap-2 flex flex-col">
          <span>Merchant Transaction SMS</span>

          <input
            formControlName="MerchantTransactionSMS"
            name="MerchantTransactionSMS"
            placeholder="Merchant Transaction SMS"
            class="w-full border p-2 rounded-md outline-none"
          />
        </div>
      </div>
    </div> -->
  </form>
</div>
